// Shared pricing card grid used by both the Landing Page and the Choose Plan
// page, so plan details only ever live in one place (src/constants/plans.js).
import React from "react";
import { Card } from "antd";

const CheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-check h-5 w-5 text-primary flex-shrink-0 mt-0.5"
  >
    <path d="M20 6 9 17l-5-5"></path>
  </svg>
);

/**
 * @param {Array} plans - plan objects, see src/constants/plans.js
 * @param {(plan: object) => React.ReactNode} renderAction - renders the
 *   footer action (button) for a given plan. Kept caller-controlled so the
 *   Landing Page can keep its static CTAs while Choose Plan can wire up
 *   plan selection, without duplicating the card markup.
 * @param {string} [className] - wrapper grid className
 */
const PricingPlans = ({
  plans,
  renderAction,
  className = "grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto animate-fade-in-up priceWraps",
}) => (
  <div className={className}>
    {plans.map((plan) => (
      <Card key={plan.id}>
        {plan.badge && (
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 bg-accent-gradient text-accent-foreground text-sm font-semibold rounded-full">
            {plan.badge}
          </div>
        )}

        <div className="mb-6">
          <h3 className="text-2xl font-bold text-card-foreground mb-2">
            {plan.name}
          </h3>
          <p className="text-muted-foreground text-sm mb-4">
            {plan.description}
          </p>
          <div className="flex items-baseline gap-1">
            <span className="text-4xl md:text-5xl font-bold text-foreground">
              {plan.price}
            </span>
            <span className="text-muted-foreground">{plan.priceSuffix}</span>
          </div>
        </div>

        <ul className="space-y-3 listsSpec">
          {plan.features.map((feature) => (
            <li key={feature} className="flex items-start gap-3">
              <CheckIcon />
              <span className="text-muted-foreground">{feature}</span>
            </li>
          ))}
        </ul>

        {renderAction(plan)}
      </Card>
    ))}
  </div>
);

export default PricingPlans;
